export enum LegalDocType {
	ASZF = "aszf",
	PRIVACY = "privacy",
	COOKIE = "cookie",
	PRIZE_GAME = "prize-game-rules",
}

const documentSegment = (value: string, fallback: string) => {
	const normalized = value.toLowerCase();

	return /^[a-z0-9-]+$/.test(normalized) ? encodeURIComponent(normalized) : fallback;
};

const documentOrigin = () => {
	try {
		return new URL(globalConfig.API).origin;
	} catch {
		return globalConfig.API.replace(/\/+$/, "").replace(/\/api\/v\d+.*$/i, "");
	}
};

export const getDocumentUrl = (type: LegalDocType, region = "hu", lang = "hu") => {
	const safeRegion = documentSegment(region, "hu");
	const safeType = documentSegment(type, LegalDocType.PRIVACY);
	const safeLang = documentSegment(lang, "hu");

	return `${documentOrigin()}/documents/latest/${safeRegion}/${safeType}/${safeLang}`;
};
